import type { DriveFile, DriveFolder } from '../types';

interface Props {
  show: boolean;
  items: (DriveFile | DriveFolder)[];
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  deleting?: boolean;
}

export default function DeleteModal({ show, items, onConfirm, onCancel, deleting = false }: Props) {
  if (!show) return null;

  const itemCount = items.length;
  const itemNames = items.map(item => item.name).join(', ');
  const displayNames = itemCount <= 3 ? itemNames : `${items.slice(0, 3).map(i => i.name).join(', ')} y ${itemCount - 3} más`;

  return (
    <div className="modal d-block feebbo-modal" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onCancel}>
      <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title d-flex align-items-center gap-2">
              <i className="bi bi-exclamation-triangle-fill" style={{ color: '#dc2626', fontSize: 20 }} />
              <span>Confirmar eliminación</span>
            </h5>
            <button type="button" className="btn-close" onClick={onCancel} />
          </div>
          <div className="modal-body">
            <p className="mb-2">
              {itemCount === 1 
                ? `¿Estás seguro de que deseas eliminar "${items[0].name}"?`
                : `¿Estás seguro de que deseas eliminar ${itemCount} elementos?`
              }
            </p>
            {itemCount > 1 && (
              <div className="small text-body-secondary mb-3">
                {displayNames}
              </div>
            )}
            <div 
              className="alert d-flex align-items-start gap-2 mb-0" 
              style={{ 
                background: '#fef2f2', 
                border: '1px solid #fecaca', 
                color: '#991b1b',
                fontSize: '13px'
              }}
            >
              <i className="bi bi-info-circle-fill mt-1" style={{ flexShrink: 0 }} />
              <div>
                <strong>Esta acción no se puede deshacer.</strong>
                <div className="mt-1">Los elementos se eliminarán permanentemente del almacenamiento.</div>
              </div>
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button 
              type="button" 
              className="btn btn-feebbo-outline" 
              onClick={onCancel}
              disabled={deleting}
            >
              Cancelar
            </button>
            <button 
              type="button" 
              className="btn btn-outline-danger" 
              onClick={onConfirm}
              disabled={deleting}
              style={{ 
                backgroundColor: '#dc2626',
                borderColor: '#dc2626',
                color: '#ffffff',
                opacity: deleting ? 0.6 : 1
              }}
            >
              {deleting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" style={{ width: 14, height: 14 }} />
                  Eliminando...
                </>
              ) : (
                <>
                  <i className="bi bi-trash me-1" />
                  Eliminar {itemCount > 1 ? `${itemCount} elementos` : ''}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
